import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, take } from 'rxjs/operators';

import { INavigationApplicationInterface, INavigationConfigurationInterface } from '@ispm/navigation/interfaces';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';

@Injectable()
export class ApplicationConfigService {
  public DEFAULT: string = 'default';

  private resourceUri = 'entity-tree/AppConfiguration/search';

  constructor(
    private ispmHttpService: IspmHttpClient,
    private store: Store<IgenomicsState>
  ) {
  }

  public getAppConfiguration(navigationConfig: INavigationConfigurationInterface, allowEmptyOrg: boolean = false): Observable<INavigationConfigurationInterface> {
    return this.store.select('users', 'organizationConfiguration')
      .pipe(
        filter(org => !!org || allowEmptyOrg),
        take(1),
        map(org => org || { }),
        switchMap(org => {
          let ids = [];

          if (Array.isArray(org['applications'])) {
            ids = org['applications'].reduce((arr, app) => {
              if (app.appId) {
                arr.push(app.appId);
              }
              return arr;
            }, []);
          }

          return this.ispmHttpService.post('application/getApp', {'_id': ids.join(',')})
            .pipe(map(res => ([org, res])));
        }),
        map(([org, applications]: [any, Array<INavigationApplicationInterface>]) => {
          if (applications && applications.length > 1) {
            navigationConfig.isAppConfigEnabled = true;
            const navObject = navigationConfig.navigation.items.find((item) => (item.identify === 'patientNav' && item.hasOwnProperty('showCreatePatientButton')));
            navigationConfig.navigation.items = [];
            navigationConfig.navigation.applications = [];
            navigationConfig.navigation.availableapplications = applications;

            applications.forEach((application) => {
              navigationConfig.navigation.applications.push(application);

              if (Array.isArray(application.items)) {
                application.items.forEach((item) => {
                  if (item.identify === 'patientNav') {
                    item.showCreatePatientButton = !!navObject ? navObject.showCreatePatientButton : true;
                  }
                });
                navigationConfig.navigation.items.push(...application.items);
              }
            });
          } else {
            navigationConfig.isAppConfigEnabled = false;
          }

          return navigationConfig;
        })
      );
  }

  public getAllAppConfigurations(): Promise<INavigationApplicationInterface[]> {
    return this.ispmHttpService.post('application/getApp', {}).pipe(take(1)).toPromise();
  }

  public initAppConfiguration(): Observable<Array<INavigationApplicationInterface>> {
    return this.ispmHttpService.post(this.resourceUri, '').pipe(
      map((applications: Array<INavigationApplicationInterface>) => {
        return applications;
      })
    );
  }

  public getDefaultApplication(): Array<INavigationApplicationInterface> {
    return [{
      'text': 'Default Application',
      'enable': true,
      'headerTitle': 'Default Application',
      'resources': [],
      'icon': 'icon__Philips',
      'id': this.DEFAULT,
      'allowInitialLoad': true,
      'type': 'application',
      'testMemory': undefined
    }];
  }
}
